<template>
	<header class="sk-navigation-header">
		<div class="sk-navigation-header__main">
			<h1>{{ title }}</h1>
			<h2 v-if="hasValue">{{ subtitle }}</h2>
		</div>
		<div class="sk-navigation-header__extra">
			<slot></slot>
		</div>
	</header>
</template>

<script>
export default {
	name: 'navigation-header',
	props: {
		title: {
			type: String,
			default: ''
		},
		subtitle: {
			type: String,
			default: null
		}
	},
	computed: {
		hasValue() {
			return this.subtitle != null && this.subtitle != ''
		}
	}
}
</script>

<style scoped>
.sk-navigation-header {
	background-color: var(--main-color);
	display: flex;
	flex-direction: row;
	justify-content: center;
	height: var(--topbar-height);
	width: 100%;
}
.sk-navigation-header__main {
	background-color: var(--main-color);
	height: var(--topbar-height);
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
h1 {
	margin: 0;
	padding: 0;
	color: #fff;
	font-weight: 900;
	font-size: 18px;
	padding: 0 0 0 50px;
}
h2 {
	margin: 0;
	padding: 0;
	color: #fff;
	font-weight: 300;
	font-size: 12px;
	padding: 0 0 0 50px;
	opacity: 0.5;
}
</style>


// WEBPACK FOOTER //
// src/components/navigation/NavigationHeader.vue